export enum Motivo{
    ViagemNaoLocalizada = 1,
    ViagemFinalizada = 2,
    CPFNaoLocalizado = 3,
    PreCheckoutAprovado = 4,
    PreCheckoutJaRealizado = 5,
    CPFHabilitadoTLC = 6,
    CPFNaoHabilitadoTLC = 7
}